<template>
  <div class="grid grid-cols-12 gap-4 md:gap-6 px-4 pb-12">
    <div class="col-span-12">
      <DataFetcher dataKey="balances">
        <template #any="{ data, refresh, loading, loadingError }">
          <div class="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-4">
        <div class="rounded-2xl border border-gray-200 bg-white p-5">
          <div class="flex justify-between mb-4">
            <p class="text-gray-500 text-lg">Solde Client</p>
            <div
              class="w-8 h-5 cursor-pointer flex justify-center"
              @click="showCustomerBalance = !showCustomerBalance"
            >
              <ColorImg
                src="/images/icons/eye.png"
                class="bg-current w-5 h-5"
              />
            </div>
          </div>
          <div class="flex items-end justify-between mt-3">
            <div class="flex justify-between">
              <h4 class="text-xl font-bold text-gray-800 whitespace-nowrap">
                <div v-if="showCustomerBalance">
                  
                      <div
                        class="flex items-center gap-2 cursor-pointer"
                        @click="
                          () => {
                            if (loadingError) refresh()
                          }
                        "
                        :class="{
                          'text-red-500': loadingError,
                        }"
                      >
                        <div>
                          {{
                            loading
                              ? 'chargement...'
                              : loadingError
                                ? 'erreur...'
                                : `${data?.customerBalance || 0} FCFA`
                          }}
                        </div>
                        <div
                          v-if="loadingError || loading"
                          class="w-5 h-5"
                          :class="{ 'animate-spin': loading }"
                        >
                          <ColorImg
                            src="/images/icons/refresh.png"
                            class="bg-current"
                          />
                        </div>
                      </div>
                    
                </div>
                <div v-else>********</div>
              </h4>
            </div>
          </div>
        </div>

        <!-- Solde Restaurants -->
        <div class="rounded-2xl border border-gray-200 bg-white p-5">
          <div class="flex justify-between mb-4">
            <p class="text-gray-500 text-lg">Solde Restaurants</p>
            <div
              class="w-5 h-5 cursor-pointer"
              @click="showRestaurantBalance = !showRestaurantBalance"
            >
              <ColorImg src="/images/icons/eye.png" class="bg-current" />
            </div>
          </div>
          <div class="flex items-end justify-between mt-3">
            <div>
              <h4 class="text-xl font-bold text-gray-800 whitespace-nowrap">
                <div v-if="showRestaurantBalance">
                  
                      <div
                        class="flex items-center gap-2 cursor-pointer"
                        @click="
                          () => {
                            if (loadingError) refresh()
                          }
                        "
                        :class="{
                          'text-red-500': loadingError,
                        }"
                      >
                        <div>
                          {{
                            loading
                              ? 'chargement...'
                              : loadingError
                                ? 'erreur...'
                                : `${data?.restaurantBalance || 0} FCFA`
                          }}
                        </div>
                        <div
                          v-if="loadingError || loading"
                          class="w-5 h-5"
                          :class="{ 'animate-spin': loading }"
                        >
                          <ColorImg
                            src="/images/icons/refresh.png"
                            class="bg-current"
                          />
                        </div>
                      </div>
                    
                </div>
                <div v-else>********</div>
              </h4>
            </div>
          </div>
        </div>

        <!-- Solde en attente -->
        <div class="rounded-2xl border border-gray-200 bg-white p-5">
          <div class="flex justify-between mb-4">
            <p class="text-gray-500 text-lg">Solde en attente</p>
            <div
              class="w-5 h-5 cursor-pointer"
              @click="showPendingBalance = !showPendingBalance"
            >
              <ColorImg src="/images/icons/eye.png" class="bg-current" />
            </div>
          </div>
          <div class="flex items-end justify-between mt-3">
            <div>
              <h4 class="text-xl font-bold text-gray-800 whitespace-nowrap">
                <div v-if="showPendingBalance">
                  
                      <div
                        class="flex items-center gap-2 cursor-pointer"
                        @click="
                          () => {
                            if (loadingError) refresh()
                          }
                        "
                        :class="{
                          'text-red-500': loadingError,
                        }"
                      >
                        <div>
                          {{
                            loading
                              ? 'chargement...'
                              : loadingError
                                ? 'erreur...'
                                : `${data?.pendingBalance || 0} FCFA`
                          }}
                        </div>
                        <div
                          v-if="loadingError || loading"
                          class="w-5 h-5"
                          :class="{ 'animate-spin': loading }"
                        >
                          <ColorImg
                            src="/images/icons/refresh.png"
                            class="bg-current"
                          />
                        </div>
                      </div>
                    
                </div>
                <div v-else>********</div>
              </h4>
            </div>
          </div>
        </div>

        <!-- Solde Rider -->
        <div class="rounded-2xl border border-gray-200 bg-white p-5">
          <div class="flex justify-between mb-4">
            <p class="text-gray-500 text-lg">Solde Rider</p>
            <div
              class="w-5 h-5 cursor-pointer"
              @click="showRiderBalance = !showRiderBalance"
            >
              <ColorImg src="/images/icons/eye.png" class="bg-current" />
            </div>
          </div>
          <div class="flex items-end justify-between mt-3">
            <div>
              <h4 class="text-xl font-bold text-gray-800 whitespace-nowrap">
                <div v-if="showRiderBalance">
                  
                      <div
                        class="flex items-center gap-2 cursor-pointer"
                        @click="
                          () => {
                            if (loadingError) refresh()
                          }
                        "
                        :class="{
                          'text-red-500': loadingError,
                        }"
                      >
                        <div>
                          {{
                            loading
                              ? 'chargement...'
                              : loadingError
                                ? 'erreur...'
                                : `${data?.riderBalance || 0} FCFA`
                          }}
                        </div>
                        <div
                          v-if="loadingError || loading"
                          class="w-5 h-5"
                          :class="{ 'animate-spin': loading }"
                        >
                          <ColorImg
                            src="/images/icons/refresh.png"
                            class="bg-current"
                          />
                        </div>
                      </div>
                    
                </div>
                <div v-else>********</div>
              </h4>
            </div>
          </div>
        </div>
          </div>
        </template>
      </DataFetcher>
    </div>
    <div class="col-span-12">
      <DataFetcher dataKey="platformStats" v-slot="{ data, loading, error, refresh }">
        <div v-if="loading" class="text-center py-10">Chargement des statistiques...</div>
        <div v-else-if="error" class="text-center text-red-500 py-10">Erreur lors du chargement des statistiques. <button @click="refresh">Réessayer</button></div>
        <div v-else class="grid grid-cols-12 gap-4 md:gap-6">
          <div class="col-span-12">
            <CommissionsChart :statsData="data?.commissions" />
          </div>
          <div class="col-span-12 xl:col-span-7">
            <DirectRevenueChart :statsData="data?.directRevenues" />
          </div>
          <div class="col-span-12 xl:col-span-5">
            <MomoVsCashChart :statsData="data?.payments" />
          </div>
          <div class="col-span-12 xl:col-span-5">
            <TopFeaturesStats :statsData="data?.cities" />
          </div>
          <div class="col-span-12 xl:col-span-7">
            <OperationsChart :statsData="data?.operations" />
          </div>
        </div>
      </DataFetcher>
    </div>

    <div class="col-span-12">
      <TableList
        title="20 dernières commandes"
        dataKey="lastOperations"
        hidePagination
        :cols="[
          {
            name: 'Plat',
            image(el) {
              return el.dishImage
            },
            value(el) {
              return [el.dishName]
            },
          },
          {
            name: 'Date',
            value(el) {
              return Commons.time(el.date)
            },
          },
          {
            name: 'Client',
            value(el) {
              return el.customerName || ''
            },
          },
          {
            name: 'Restaurant',
            value(el) {
              return el.restaurantName || ''
            },
          },
          {
            name: 'Montant',
            value(el) {
              const price = el.price !== undefined && el.price !== null ? el.price : 0
              return `${price} FCFA`
            },
          },
          {
            name: 'Statut',
            value(el) {
              const statusMap = {
                delivered: `<span class='inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-700'>Livré</span>`,
                cancelled: `<span class='inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-700'>Annulé</span>`,
                rejected: `<span class='inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-700'>Refusé</span>`,
                pending: `<span class='inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-700'>En attente</span>`,
                confirmed: `<span class='inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-700'>Confirmé</span>`,
                preparing: `<span class='inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-700'>En préparation</span>`,
                picked_up: `<span class='inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-700'>Récupéré</span>`,
                ready_for_pickup: `<span class='inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-700'>Prêt</span>`,
              }
              return statusMap[el.status] || `<span class='inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600'>${el.status || '-'}</span>`
            },
          },
        ]"
      ></TableList>
    </div>
  </div>
</template>

<script>
import Translator from '@/shared/utils/translator'
import DataFetcher from '@/features/data/presentation/components/DataFetcher.vue'
import Events from '@/events/events'
import Commons from '@/shared/utils/commons'
import { Countries } from '@/shared/utils/countries'
import { EVENTS } from '@/shared/constants/commons'
import { CUSTOM_EVENTS } from '@/project/configs/customConstants'
import PermissionsManager from '@/shared/utils/permissionsManager'
import StatisticsChart from '../charts/StatisticsChart.vue'
import OperationsChart from '../charts/OperationsChart.vue'
import CommissionsChart from '../charts/CommissionsChart.vue'
import DirectRevenueChart from '../charts/DirectRevenueChart.vue'
import ColorImg from '@/presentation/components/img/ColorImg.vue'
import TopFeaturesStats from '../charts/TopFeaturesStats.vue'
import MomoVsCashChart from '../charts/MomoVsCashChart.vue'
import TableList from '../others/TableList.vue'

export default {
  name: 'DashboardPage',
  components: {
    ColorImg,
    DataFetcher,
    StatisticsChart,
    OperationsChart,
    CommissionsChart,
    DirectRevenueChart,
    TopFeaturesStats,
    MomoVsCashChart,
    TableList,
  },
  setup() {
    Translator.setLang('fr')
    return { Translator, Commons, Countries }
  },
  data() {
    return {
      showCustomerBalance: true,
      showRestaurantBalance: true,
      showPendingBalance: true,
      showRiderBalance: true,
      visibleBalance: {},
      balances: {},
      stats: { notDownloaded: true },
      selectedPeriod: {},
      topStats: [
        {
          id: 'mainBalance',
          icon: '/images/all/money-_1_.svg',
          name: this.$t('pages.dashboard.mainBalance'),
        },
        {
          id: 'pendingBalance',
          icon: '/images/all/money-_1_.svg',
          name: this.$t('pages.dashboard.pendingBalance'),
        },
        {
          id: 'commissionBalance',
          icon: '/images/all/money-_2_.svg',
          name: this.$t('pages.dashboard.commissionBalance'),
        },
      ],
      bottomStats: [
        {
          id: 'walletWithdraw',
          name: this.$t('pages.dashboard.weekWithdraw'),
        },
        {
          id: 'walletCredit',
          name: this.$t('pages.dashboard.weekCredit'),
        },
      ],
      statsAreVisible: false,
      periods: [
        {
          name: "Ajourd'hui",
          id: 'day',
          previousId: 'yesterday',
          previousName: 'Hier',
        },
        {
          name: 'Semaine',
          id: 'week',
          previousId: 'lastWeek',
          previousName: 'Semaine passée',
        },
        {
          name: 'Mois',
          id: 'month',
          previousId: 'lastMonth',
          previousName: 'Mois passé',
        },
      ],
    }
  },
  beforeUnmount() {},
  mounted() {
    this.selectedPeriod = this.periods[1]
  },
  methods: {
    showStats() {
      this.statsAreVisible = true
    },
    hideStats() {
      this.statsAreVisible = false
    },
    toggleBalanceVisibility(id) {
      this.visibleBalance[id] = !this.visibleBalance[id]
      this.$forceUpdate()
    },
    requestWithdraw() {
      Events.dispatch('request_withdrawal_launching')
    },
    async initFunding() {
      const options = [
        {
          id: 'bankAccount',
          name: this.$t(
            'pages.dashboard.fundAccount.choiceMethod.bankAccount',
            {},
            false,
          ),
        },
        {
          id: 'crypto',
          name: this.$t(
            'pages.dashboard.fundAccount.choiceMethod.crypto',
            {},
            false,
          ),
        },
      ]
      const prompt = await window.choicePrompt({
        title: this.$t(
          'pages.dashboard.fundAccount.choiceMethod.title',
          {},
          false,
        ),
        subTitle: this.$t(
          'pages.dashboard.fundAccount.choiceMethod.description',
          {},
          false,
        ),
        options: options,
        formatDisplay: data => data?.name || '',
        selectOnClick: true,
      })
      if (!prompt.accepted || !prompt.success) return
      if (prompt.data?.id == 'crypto') {
        Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
          title: this.$t(
            'pages.dashboard.fundAccount.choiceMethod.cryptoSoonAvailableTitle',
            {},
            false,
          ),
          body: this.$t(
            'pages.dashboard.fundAccount.choiceMethod.cryptoNotAvailableYet',
            {},
            false,
          ),
        })
      } else if (prompt.data?.id == 'bankAccount') {
        this.fundWithBank()
      }
    },
    fundWithBank() {
      Events.dispatch(CUSTOM_EVENTS.SERVICE_LAUNCH_REQUEST, {
        serviceId: 'fundWithBank',
      })
    },
    fundWithCard() {
      Events.dispatch(CUSTOM_EVENTS.SERVICE_LAUNCH_REQUEST, {
        serviceId: 'fundWithCard',
      })
    },
    withdrawWithBank() {
      Events.dispatch(CUSTOM_EVENTS.SERVICE_LAUNCH_REQUEST, {
        serviceId: 'withdrawWithBank',
      })
    },
    transferBalance() {
      Events.dispatch(CUSTOM_EVENTS.SERVICE_LAUNCH_REQUEST, {
        serviceId: 'transferBalance',
      })
    },
  },
  watch: {},
}
</script>
